import React, { forwardRef } from 'react';
import { Link } from 'app/shared/link/link';
import classNames from 'classnames';
import { Image } from 'app/shared/assets';
import { Image as ImageComponent } from 'app/components/Image';
import { TooltipText } from '../../../shared/TooltipText/TooltipText';
import ContentLoader from 'react-content-loader';

export const CategoryLoader = () => {
    const width = '100%';
    return (
        <ContentLoader
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            width={300}
            height={200}
            viewBox="0 0 300 200"
            preserveAspectRatio="none"
            style={{ width }}
        >
            <rect x="0" y="0" rx="5" ry="5" width={width} height="150" />
            <rect x="0" y="170" rx="5" ry="5" width={width} height="30" />
        </ContentLoader>
    );
};

export const Category = forwardRef(
    (
        {
            title,
            id,
            img,
            active,
            onAddImage,
            onEdit,
            onDelete,
            allowEdit,
            className,
            tooltip,
        },
        ref
    ) => {
        return (
            <Link
                className={classNames({ 'category-link': active })}
                to={`/categories/${id}`}
            >
                <div
                    id={id}
                    ref={ref}
                    className={classNames(
                        active ? 'sub-category' : 'category',
                        className
                    )}
                >
                    {img ? (
                        <ImageComponent
                            src={img}
                            onClick={
                                allowEdit
                                    ? (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                      }
                                    : undefined
                            }
                            onEdit={allowEdit ? onEdit : null}
                            onDelete={allowEdit ? onDelete : null}
                        />
                    ) : allowEdit ? (
                        <div
                            id={'category-no-image'}
                            className={'category__no-image'}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onAddImage(id);
                            }}
                        >
                            <Image />
                            Добавить изображение
                        </div>
                    ) : null}
                    <TooltipText
                        ellipsis={tooltip ? { rows: 2, tooltip: title } : false}
                        className={classNames('category__title', {
                            category__title_nowrap: !tooltip,
                        })}
                    >
                        {title}
                    </TooltipText>
                </div>
            </Link>
        );
    }
);
